import React, { FC, useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import { Link, useHistory, useLocation, useParams } from 'react-router-dom'
import { LangValue } from '../../../../states/types/common'
import { setPath, setUrlId } from '../../../../utils/url'
import { URL } from '../../../constants/url'
import Tips from '../../../components/common/Tips'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { isManager } from '../../../../utils/role'
import { fetchTaskReportLabelGroup } from '../../../../states/containers/task/taskSlice'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../../../states/containers/store'
import { uniqueId } from 'lodash'
import { format } from '../../../../utils/date'

const Index: FC = () => {
  const {
    task,
    commonPart,
  } = useSelector((state: RootState) => state)

  const history = useHistory()
  const { language } = useParams<{ language: LangValue }>()
  const location = useLocation()
  const dispatch = useDispatch()

  const DISPLAY_LIMIT = 100

  const [pageOffset, setPageOffset] = useState<number>(1)
  const [isDisplayInprogress, setIsDisplayInprogress] = useState<boolean>(true)

  const clickDetail = (id: number) => {
    history.push(`${setPath(setUrlId(URL.TASK_DETAIL_DETAIL.path, 'id', id), language)}`)
  }

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [location])

  useEffect(() => {
    if (!isManager(commonPart.role)) return
    dispatch(fetchTaskReportLabelGroup({
      page: pageOffset,
      limit: DISPLAY_LIMIT,
      disabled: !isDisplayInprogress,
    }))
  }, [pageOffset, isDisplayInprogress])

  return (
    <section className="task_page">
      <Helmet>
        <title>Qasee - 工数管理 - プロジェクト詳細(tp)</title>
      </Helmet>
      <section className="breadcrumb">
        <Link
          to={setPath(URL.TASK.path, language)}
        >
          工数管理
        </Link>
        &nbsp;&gt;&nbsp;
        プロジェクト詳細
        &nbsp;
      </section>
      <section className="page_header">
        <h1>
          プロジェクト詳細
        </h1>
      </section>
      <section className="page_contents content-area">
        <div className="content-block">
          <div className="block-header">
            <div className="title">
              プロジェクト詳細
            </div>
          </div>
          <div className="block-detail">
            <div className="report_table">
              <div className="row_head">
                <div>
                  確認
                </div>
                <div>
                  プロジェクト名
                </div>
                <div>
                  開始日
                </div>
              </div>
              {
                task.taskReportLabelGroup?.label_groups.map((v) => (
                  <div
                    className="row"
                    key={uniqueId()}
                  >
                    <div>
                      <Tips
                        description="詳細を見る"
                        className=""
                        icon={false}
                      >
                        <>
                          <FontAwesomeIcon
                            icon={['fas', 'file-alt']}
                            style={{ cursor: "pointer" }}
                            onClick={() => clickDetail(v.id)}
                          />
                        </>
                      </Tips>
                    </div>
                    <div>
                      {v.name}
                    </div>
                    <div>
                      {format(v.schedule.start_date, "YYYY年MM月DD日")}
                    </div>
                  </div>
                ))
              }
            </div>
          </div>
        </div>
      </section>
    </section>
  )
}

export default Index
